import { Component } from "react";
import { AlertOctagon, RotateCw } from "lucide-react";

// Red de seguridad global: si un render lanza (fecha corrupta, dato inesperado, etc.)
// esto evita la pantalla en blanco y deja registro del error en consola.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { tieneError: false };
  }

  static getDerivedStateFromError() {
    return { tieneError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error no controlado en la interfaz:", error, info);
  }

  render() {
    if (this.state.tieneError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[var(--tc-surface)] px-5 text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-500">
            <AlertOctagon size={26} />
          </span>
          <h1 className="text-lg font-semibold text-[var(--tc-text)]">Algo salió mal</h1>
          <p className="max-w-sm text-sm text-[var(--tc-text-secondary)]">
            La página tuvo un error inesperado. Recargá para seguir.
          </p>
          <button
            data-testid="error-boundary-reload"
            onClick={() => window.location.reload()}
            className="mt-2 inline-flex items-center gap-2 rounded-[var(--tc-radius)] bg-[var(--tc-accent)] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--tc-accent-hover)]"
          >
            <RotateCw size={15} /> Recargar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
